"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaselineSplitter = BaselineSplitter;
const isArabic_1 = require("./isArabic");
const reference_1 = require("./reference");
function BaselineSplitter(word) {
    let letters = [];
    let lastLetter = '';
    word.split('').forEach((letter) => {
        if ((0, isArabic_1.isArabic)(letter) && (0, isArabic_1.isArabic)(lastLetter)) {
            if (lastLetter.length && reference_1.tashkeel.indexOf(letter) > -1) {
                letters[letters.length - 1] += letter;
            }
            else if (reference_1.lineBreakers.indexOf(lastLetter) > -1) {
                letters.push(letter);
            }
            else {
                letters[letters.length - 1] += letter;
            }
        }
        else {
            letters.push(letter);
        }
        if (reference_1.tashkeel.indexOf(letter) === -1) {
            // don't allow tashkeel to hide line break
            lastLetter = letter;
        }
    });
    return letters;
}
